import React from "react";
import "./HomeContent.css";
import { useState } from "react";
import { Box, Button, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material/styles";
import QA from "./QA";
import Grid from "@mui/material/Grid";
import QARightSection from "./QARightSection";
import HowItWorks from "./HowItWorks";
import PostQuestionModal from "../PostQuestionModel/PostQuestionModal";

function HomeContent() {

  const [refreshQuestions, setRefreshQuestions] = useState(false);
  const [openPostModal, setOpenPostModal] = useState(false);
  const theme = createTheme({
    typography: {
      fontFamily: "Graphik-Regular",
    },
  });

  return (
    <>
      <ThemeProvider theme={theme}>
        {/* Banner */}
        <div className="homebanner_container">
          <img
            src={process.env.PUBLIC_URL + "/images/Home/homebanner.png"}
            alt="banner"
            className="homeBannerImg"
          />
          <div className="homebannerContentSection">
            <p>Community of Learning</p>
            <span>Empowering Learning, Collaboration, and Innovation</span>
          </div>
        </div>

        {/* Main Layout */}
        <Grid className="homeContainer">
        <Grid container spacing={2} sx={{ mt: 5 }} className="mainLayoutContainer">
          {/* 70% Section */}
          <Grid item xs={12} md={8} className="leftContainerGrid">
            <Box className="postqueSearchSection">
              {/* Left: Button */}
              <Button
                variant="contained"
                className="postQuestionBtn"
                onClick={() => setOpenPostModal(true)}
              >
                Post Question
              </Button>

              {/* Right: Search */}
              <TextField
                variant="standard"
                placeholder="Search"
                className="searchInput"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ fontSize: 18 }} />
                    </InputAdornment>
                  ),
                  disableUnderline: false,
                }}
                inputProps={{
                  style: {
                    fontSize: "14px",
                  },
                }}
              />
            </Box>
            <QA refreshQuestions={refreshQuestions} />
          </Grid>

          {/* 30% Section */}
          <Grid item xs={12} md={4} className="rightContainerGrid">
            <QARightSection/>
          </Grid>
        </Grid>
        <Grid item xs={12} className="howItWorksContainer">
            <HowItWorks/>
          </Grid>
        </Grid>
      </ThemeProvider>
      <PostQuestionModal
        open={openPostModal}
        onClose={() => setOpenPostModal(false)}
        onPostSuccess={() => setRefreshQuestions(prev => !prev)}
      />
    </>
  );
}

export default HomeContent;
